<template>
  <b-container style="margin-top:15px">
    <b-row>
      <b-card-group deck v-loading="loading">
        <b-card header="Sayfa Ekle" header-tag="header">
            <b-row>
              <b-col cols="2">
                  <b-form-group label="Sayfa Adı">
                    <b-form-input size="sm" v-model="form.title" placeholder="Sayfa Adı"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Sayfa Url">
                    <b-form-input size="sm" v-model="form.url" placeholder="Url"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Durum">
                    <b-form-select size="sm" v-model="form.status" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="1">Aktif</b-form-select-option>
                      <b-form-select-option :value="0">Pasif</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="12">
                  <b-form-group label="Sayfa İçeriği">
		                <ckeditor v-model="form.body"></ckeditor>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Ekle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'PagesCreate',
    data(){
      return{
        loading: false,
        form:{
          title:null,
          body:null,
          url:null,
          status:null,
        }
      }
    },
    created(){
    },
    methods:{
      send(){
        this.loading = true;
        axios.post('/page/create', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'warning', title: 'Ekleme Başarılı'});
            this.$router.push({name: 'Pages'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>